module.exports = __webpack_public_path__ + "static/img/11.-HDD-Power-Supply-Cable.fee4a19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/11.-HDD-Power-Supply-Cable.jpg
// module id = WuRe
// module chunks = 1